module.exports = "\r\n\r\n.row{\r\n    padding: 1em 0px 0px 0px !important;\r\n    margin-bottom: -10px;\r\n}\r\n\r\ntd{\r\n    border: 1px solid #ddd;\r\n}\r\n\r\n.mandatory{\r\n    color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/khbnotification/form/form.component.css
// module id = ./src/app/allocation/khbnotification/form/form.component.css
// module chunks = main